import React from 'react';
import classNames from 'classnames';
import HighlightCellHelper from 'main/components/show/cuesheet/highlightCellHelper';
import PresetDuration from 'main/components/show/cuesheet/presetDuration';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

const SimplePresetDurationCell = (props) => {
  const {
    item,
    userId,
    isSelected,
    presetDurationDisplayType,
    displayPresetDuration,
  } = props;

  const wrapperClasses = classNames(
    'cs-simple-cell-wrapper',
    HighlightCellHelper.getPersonalHighlightClass(item, userId),
  );

  const cellClasses = classNames('cs-cell cs-data-cell', {
    'cs-cell-selected': isSelected,
  });

  return (
    <div
      className={wrapperClasses}
      style={HighlightCellHelper.getPersonalHighlightStyle(item, userId)}
    >
      <div
        style={HighlightCellHelper.getGlobalHighlightStyle(item)}
        className={cellClasses}
      >
        <PresetDuration
          presetDurationDisplayType={presetDurationDisplayType}
          displayPresetDuration={displayPresetDuration}
          isSelected={isSelected}
          simple
          value={item.get('presetDurationInSecondsAdjusted')}
          {...props}
        />
      </div>
    </div>
  );
};

export default SimplePresetDurationCell;
